
export type TrendItemContentTweetsItemReferencedTweetType = typeof TrendItemContentTweetsItemReferencedTweetType[keyof typeof TrendItemContentTweetsItemReferencedTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendItemContentTweetsItemReferencedTweetType = {
  REPLIED_TO: 'REPLIED_TO',
  QUOTED: 'QUOTED',
  RETWEETED: 'RETWEETED',
} as const;
